import React from 'react';
import { Box, Typography } from '@mui/material';

type Props = {
  reviewCount?: {
    [text: string]: number
  };
  text: string,
  total: number,
  fontWeight?: number,
}

const getReviewAggregation = (
  total: number, reviewCount?: number,
): React.ReactNode | null => {
  if (!reviewCount) {
    return null;
  }
  const nonReviewedCount = total - reviewCount;

  return reviewCount ? (
    <>
      {' ('}
      <Typography component="span" sx={{ color: 'royalblue', fontWeight: 'bold', fontSize: 'inherit' }}>{reviewCount}</Typography>
      <Typography component="span" sx={{ fontWeight: 'bold', fontSize: 'inherit' }}>/</Typography>
      <Typography component="span" sx={{ color: 'red', fontWeight: 'bold', fontSize: 'inherit' }}>{nonReviewedCount}</Typography>
      {') '}
    </>
  ) : '';
};

export const FormattedAggregatedResult = ({
  reviewCount, text, total, fontWeight,
}: Props): React.ReactElement => (
  <Box key={text}>
    <Typography component="span" fontWeight={fontWeight} color={!fontWeight ? 'grey.500' : ''}>
      {`${text} `}
    </Typography>
    <Typography variant="body2" color="grey.500" component="span">
      {`×${total}`}
      {getReviewAggregation(total, reviewCount && reviewCount[text])}
    </Typography>
  </Box>
);

export const FormattedAggregatedResultNumberRange = ({
  reviewCount, text, total, fontWeight,
}: Props): React.ReactElement => (
  <Box key={text}>
    <Typography component="span" fontWeight={fontWeight} color={!fontWeight ? 'grey.500' : ''}>
      {`[${text}] `}
    </Typography>
    <Typography variant="body2" color="grey.500" component="span">
      {`×${total}`}
      {getReviewAggregation(total, reviewCount && reviewCount[text])}
    </Typography>
  </Box>
);

type FormattedAggregatedResultSingleChoiceWithTextType = {
  reviewCount: number,
  text: string,
  total: number,
  correct?: boolean,
}

export const FormattedAggregatedResultSingleChoiceWithText = ({
  reviewCount, text, total, correct,
}: FormattedAggregatedResultSingleChoiceWithTextType): React.ReactElement => (
  <>
    <Typography component="span" sx={correct ? { fontWeight: 500 } : {}}>
      {`${text} `}
    </Typography>
    <Typography variant="body2" color="grey.500" component="span">
      {`×${total}`}
      {getReviewAggregation(total, reviewCount)}
    </Typography>
  </>
);
